// src/components/BreadcrumbNav.js
import React from "react";
import { useLocation, Link } from "react-router-dom";

const labels = {
  ueberblick: "Überblick",
  hintergrund: "Hintergrund",
  


  krebsgesamt: "Krebs-Häufigkeiten",
  haeufigste_krebserkrankungen: "Häufigste Krebserkrankungen",
  ueberleben_5: "Überleben",
  zeitverlauf: "Neuerkrankungen im Zeitverlauf",
 regionale_verteilung: "Regionale Verteilung",

  entit: "Klinik und Follow-up",
  altersverteilung: "Altersverteilung",
  tnm: "TNM",
  stage: "Stadium",
  grading: "Grading",
  lokal: "Lokalisation",
  histo: "Histologie",
  met: "Metastasierung",
  rs_entit: "Überleben",
  therapie: "Therapien",

  methodik: "Methodik",
  datenqualitaet: "Datenqualität",
  definitionen: "Definitionen",
  datengrundlage: "Datengrundlage",
  kennzahlen: "Kennzahlen",

  regional: "Regionale Darstellung",
 
};

const labelFor = (segment) => labels[segment] || segment;

const BreadcrumbNav = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean);
  const crumbs = parts.map((part, idx) => ({
    path: "/" + parts.slice(0, idx + 1).join("/"),
    label: labelFor(part),
    isLast: idx === parts.length - 1,
  }));

  return (
    <nav className="breadcrumb-nav" aria-label="Breadcrumb">
      <div className="breadcrumb-nav-inner">
        {/* This wrapper is REQUIRED for alignment & spacing */}
        <div className="breadcrumb-nav-content">
          <Link to="/">Startseite</Link>
          {crumbs.map(({ path, label, isLast }) => (
            <span key={path}>
              {" › "}
              {isLast ? <span>{label}</span> : <Link to={path}>{label}</Link>}
            </span>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default BreadcrumbNav;

